var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.937 13.898c.054.65.646 1.125 1.292 1.125h1.136v.715A2.26 2.26 0 0117.116 18H10.25A2.26 2.26 0 018 15.738V11.69a2.26 2.26 0 012.25-2.261h6.866a2.26 2.26 0 012.25 2.261v.867h-1.209c-.335 0-.64.132-.861.36a1.212 1.212 0 00-.36.98z",
    fill: "#655AEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.41c0 .33-.263.6-.598.613h-1.173c-.646 0-1.238-.475-1.292-1.125a1.212 1.212 0 01.36-.98c.22-.229.526-.361.86-.361h1.245a.616.616 0 01.598.613v1.24zM10.692 12.534c-.245 0-.449-.227-.449-.5s.204-.5.449-.5h4.187c.245 0 .449.227.449.5s-.204.5-.449.5h-4.187z",
    fill: "#FEAAFF"
  })))));
}

export default SvgViews;